import BpkBadge, { BADGE_TYPES } from '@skyscanner-internal/backpack-web/bpk-component-badge';
import { FEATURE_DECISION_KEYS } from '@web-platform/shared-universal-constants-config';
import { translate } from '@web-platform/shared-universal-translations';
import { getFeatureDecision } from '@web-platform/shared-universal-utils-frontend/src/config';

import { SponsoredInfoButton } from '../SponsoredInfoButton/SponsoredInfoButton';

type Props = {
  type?: keyof typeof BADGE_TYPES;
  withInfoIcon?: boolean;
  infoIconCustomColor?: boolean;
  ariaLabel?: string;
  additionalText?: string;
  additionalTitle?: string;
  pioPartnerName?: string;
  pioAgencyName?: string;
};

export const SponsoredBadge = ({
  additionalText,
  additionalTitle,
  ariaLabel,
  infoIconCustomColor = false,
  pioAgencyName,
  pioPartnerName,
  type = BADGE_TYPES.normal,
  withInfoIcon = false,
}: Props) => {
  const dsaModalEnabled = getFeatureDecision(
    FEATURE_DECISION_KEYS.ADS_DSA_MODAL_UPDATED_WITH_LEGAL_NAME_WEB,
  );

  const prepareCallToActionData = () => {
    let whySeeingDescription: string;
    if (!dsaModalEnabled || !pioPartnerName) {
      whySeeingDescription = translate('ktxt_Ad_info_message');
    } else if (pioAgencyName && pioAgencyName !== pioPartnerName) {
      whySeeingDescription = translate('ktxt_dsa_why_seeing_body_with_agency', {
        partner: pioPartnerName,
        agency: pioAgencyName,
      });
    } else {
      whySeeingDescription = translate('ktxt_dsa_why_seeing_body_single', {
        partner: pioPartnerName,
      });
    }

    const bottomSheetContent = [
      {
        title: '',
        description: whySeeingDescription,
      },
      {
        title: translate('ktxt_dsa_based_on_now_title'),
        description: translate('ktxt_dsa_based_on_now_body'),
      },
      {
        title: translate('ktxt_dsa_based_on_past_title'),
        description: translate('ktxt_dsa_based_on_past_body'),
      },
    ];

    if (additionalText && additionalTitle) {
      bottomSheetContent.push({
        title: additionalTitle,
        description: additionalText,
      });
    }

    return {
      text: translate('ktxt_promotion_sponsored'),
      bottomSheetContent,
      bottomSheetTitle: translate('ktxt_ad_info_title'),
    };
  };
  const callToActionData = prepareCallToActionData();
  return withInfoIcon ? (
    <SponsoredInfoButton
      ariaLabel={ariaLabel}
      infoIconCustomColor={infoIconCustomColor}
      callToAction={callToActionData}
    >
      <BpkBadge type={type}>{translate('ktxt_promotion_sponsored')}</BpkBadge>
    </SponsoredInfoButton>
  ) : (
    <BpkBadge type={type}>{translate('ktxt_promotion_sponsored')}</BpkBadge>
  );
};
